import { ChangeDetectionStrategy, Component, computed, inject, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { ExperienceAreaService } from '../../../experience-area.service';
import { ExperienceSchedulingService } from '../../experience-scheduling.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'experience-scheduling-accelerator-course-assignments-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerator-course-assignments-view.part.html',
})
export class ExperienceSchedulingAcceleratorCourseAssignmentsViewPart implements OnInit {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly dialogService = inject(DialogService);
	private readonly experienceAreaService = inject(ExperienceAreaService);
	private readonly pageService = inject(ExperienceSchedulingService);

	public setup = getSetup(this.util, this.app, this.dialogService, this.experienceAreaService);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public acceleratorCourseAssignments = computed(() => {
		const data = this.experienceAreaService.experienceData()?.acceleratorCourseAssignments ?? [];
		// Add meeting display text using utility functions
		return data.map(acc => {
			const formattedData = this.util.date.formatAccMeetingSlot(acc.meetingStartSlot, acc.standardFourTimeZoneId, true, this.app.data().standardLocalTimezoneId);
			return {
				...acc,
				meetingLocalDisplayText: formattedData.localDisplayTime,
				meetingAcceleratorDisplayText: formattedData.acceleratorDisplayTime,
			};
		});
	});

	async ngOnInit() {
		await this.experienceAreaService.loadExperienceData();
	}
}
